// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';

export const useDeleteUser = () => {
  const deleteUser = (_id: number, _truncate: boolean): Promise<void> => rejectServiceClosed();

  return { deleteUser };
};
